var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fx fx-s-center justify-between" }, [
    _c(
      "div",
      { staticClass: "title fx-s-center" },
      [_c("div", { staticClass: "default-bar" }), _vm._t("default")],
      2
    ),
    _c("div", { staticClass: "right-btn" }, [_vm._t("right")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }